import { useEffect, useState, useCallback } from 'react';

export const useMute = (videoRef, onMute, onUnmute) => {
    const [isMuted, setIsMuted] = useState(false);

    const handleVolumeChange = useCallback(() => {
        const video = videoRef.current;

        const newMutedState = video.muted || video.volume === 0;
        if (newMutedState !== isMuted) {
            setIsMuted(newMutedState);
            if (newMutedState) {
                onMute?.();
            } else {
                onUnmute?.();
            }
        }
    }, [videoRef, isMuted, onMute, onUnmute]);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        setIsMuted(video.muted || video.volume === 0);
        video.addEventListener('volumechange', handleVolumeChange);

        return () => {
            video.removeEventListener('volumechange', handleVolumeChange);
        };
    }, [videoRef, handleVolumeChange]);

    return isMuted;
};
